import { useEffect, useRef, useState } from 'react'

const OPEN_EVENT = 'open-contact-modal'

export function openContactModal() {
  window.dispatchEvent(new Event(OPEN_EVENT))
}

export default function ContactModal() {
  const [isOpen, setIsOpen] = useState(false)
  const [copied, setCopied] = useState(false)
  const copyRef = useRef<HTMLButtonElement>(null)
  const triggerRef = useRef<Element | null>(null)

  useEffect(() => {
    const open = () => {
      triggerRef.current = document.activeElement
      setCopied(false)
      setIsOpen(true)
    }
    window.addEventListener(OPEN_EVENT, open)
    return () => window.removeEventListener(OPEN_EVENT, open)
  }, [])

  useEffect(() => {
    if (!isOpen) return

    const previousOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    const focusTimer = window.setTimeout(() => copyRef.current?.focus(), 50)

    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setIsOpen(false)
    }
    window.addEventListener('keydown', onKey)

    return () => {
      document.body.style.overflow = previousOverflow
      window.removeEventListener('keydown', onKey)
      window.clearTimeout(focusTimer)
      const trigger = triggerRef.current
      if (trigger instanceof HTMLElement) trigger.focus()
    }
  }, [isOpen])

  if (!isOpen) return null

  const close = () => setIsOpen(false)
  const email = 'hi@tokendance.net'

  const copyEmail = async () => {
    try {
      await navigator.clipboard.writeText(email)
    } catch {
      const textarea = document.createElement('textarea')
      textarea.value = email
      textarea.setAttribute('readonly', '')
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
    }
    setCopied(true)
  }

  return (
    <div
      className="v2-modal-overlay"
      onClick={(event) => {
        if (event.target === event.currentTarget) close()
      }}
      role="dialog"
      aria-modal="true"
      aria-labelledby="contact-modal-title"
    >
      <div className="v2-modal-card v2-contact-modal-card">
        <button
          type="button"
          className="v2-modal-close"
          onClick={close}
          aria-label="Close"
        >
          ✕
        </button>

        <h2 id="contact-modal-title" className="v2-modal-title">
          Talk to TokenDance
        </h2>
        <p className="v2-modal-lede">
          Tell us what AI workflow, LLM system, or FDE project you want to ship.
          Send a short note to:
        </p>

        <div className="v2-contact-email-row">
          <p className="v2-contact-email">{email}</p>
          <button
            ref={copyRef}
            type="button"
            className="v2-contact-copy-button"
            onClick={copyEmail}
            aria-label={copied ? 'Email copied' : 'Copy email address'}
          >
            {copied ? (
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M20 6 9 17l-5-5" />
              </svg>
            ) : (
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M8 8h11v13H8V8Z" />
                <path d="M5 16H4V3h11v1" />
              </svg>
            )}
          </button>
        </div>
      </div>
    </div>
  )
}
